import uiActionsEn from "./actions/en.json";
import keyStagesEn from "./keyStages/en.json";
import resourcesEn from "./resources/en.json";
import siteIdentity from "./siteIdentity/en.json";
import statusesEn from "./statuses/en.json";
import subjectsEn from "./subjects/en.json";
import systemMessagesEn from "./systemMessages/en.json";
import termsEn from "./terms/en.json";
import threadsEn from "./threads/en.json";

export const COMMON_NS = "common" as const;

export const CommonTranslations = {
  en: {
    [COMMON_NS]: {
      actions: uiActionsEn,
      identity: siteIdentity,
      "key-stages": keyStagesEn,
      resources: resourcesEn,
      "system-messages": systemMessagesEn,
      statuses: statusesEn,
      subjects: subjectsEn,
      terms: termsEn,
      threads: threadsEn,
    },
  },
};
